import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";

import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Recipe from "./views/Recipe.vue";
import RecipeEdit from "./views/RecipeEdit.vue";
import RecipeForm from "./views/RecipeForm.vue";
import RecipeNew from "./views/RecipeNew.vue";

Vue.use(Router);

let router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            path: "*",
            redirect: "/"
        },
        {
            path: "/login",
            name: "Login",
            component: Login
        },
        {
            path: "/",
            name: "home",
            component: Home
                /*,
                                       meta: {
                                           requiresAuth: true
                                       }*/
        },

        // {
        //     path: "/categories",
        //     name: "categories",
        //     // route level code-splitting
        //     // this generates a separate chunk (about.[hash].js) for this route
        //     // which is lazy-loaded when the route is visited.
        //     component: () =>
        //         import ( /* webpackChunkName: "about" */ "./views/Categories.vue")
        // },
        {
            path: "/recipe/:id",
            name: "recipe",
            components: {
                default: Recipe
            },
            meta: {
                requiresAuth: true
            }
        },
        /*{
            name: "recipeEdit",
            path: "/recipe/:id/edit",
            components: {
                default: RecipeEdit
            }
        },*/
        {
            name: "recipeEdit",
            path: "/recipe/:id/edit",
            components: {
                default: RecipeEdit
            },
            meta: {
                requiresAuth: true
            }
        },
        {
            name: "addNew",
            path: "/add-new",
            components: {
                default: RecipeNew
            },
            meta: {
                requiresAuth: true
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    let currentUser = firebase.auth().currentUser;

    if (requiresAuth && !currentUser) {
        next("/login");
    } else if (requiresAuth && currentUser) {
        next();
    } else {
        next();
    }
});

export default router;